export default __webpack_public_path__ + "static/media/chevron-right.6fab38b6.svg";